import { connect } from 'react-redux'

import { getCurrentApp } from 'e-submission/apps/selectors'
import { Radio } from 'common-components/radio-group'
import SendLinkRoomIdNotExist from 'e-submission/containers/Dialog/SendLinkRoomIdNotExist'
import ResumeRMS from 'e-submission/containers/Dialog/ResumeRMS'

import {
  closeNewRemoteSellingPreviewInfoModal,
  disabledEkycOnDevice,
  enableEkycOnDevice,
  setAppValue,
  closeSendingLinkModalRemoteSelling,
  closeRemoteSellingResumeModal,
} from 'e-submission/apps/actions'
import { findParentNodeTarget } from 'e-submission/components/Card/EkycDocument'
import {
  getRemoteSellingState,
  isOnDeviceEKYC,
  insurerDoesEkyc,
  payerDoesEkyc,
  getCitizenId,
  isSelectedF2F,
  isSelectedRemoteSelling,
  isForeigner,
  getPassport,
  havePayer,
} from 'e-submission/domain/data-model/form/selectors'
import NewRemoteSellingPreviewInfo from 'e-submission/containers/Dialog/NewRemoteSellingPreviewInfo'
import React from 'react'
import { IsRealDevice } from 'e-submission/utils'
import { getToggles } from 'quick-quote/feature-toggles'
import _getOr from 'lodash/fp/getOr'
import { isEmpty } from 'lodash/fp'

function faceToFaceRadioOptions(shouldShowF2fOption, checkEkycOnDevice, uncheckEkycOnDevice, isEkycOnDevice) {
  if (shouldShowF2fOption) {
    return (
      <>
        <div style={{ paddingLeft: '5%', paddingBottom: '2%', paddingTop: '2%' }}>
          {IsRealDevice && (
            <Radio
              option={{ text: 'ยืนยันตัวตน (eKYC) ผ่านระบบ AdvisorZone', value: true }}
              subOptions={{}}
              active={isEkycOnDevice}
              onClick={checkEkycOnDevice}
            />
          )}
          <Radio
            option={{ text: 'ยืนยันตัวตน (eKYC) ด้วยตนเอง ระบบจะส่ง link ผ่านช่องทาง Email หรือ SMS', value: true }}
            subOptions={{}}
            active={!isEkycOnDevice}
            onClick={uncheckEkycOnDevice}
          />
        </div>
      </>
    )
  }

  return null
}

export function checkShowingF2fOption(
  selectedRemoteSelling,
  isPayerNeedToBeEkycDone,
  isInsuredNeedToBeEkycDone,
  payerCitizenId
) {
  if (
    !selectedRemoteSelling &&
    ((isInsuredNeedToBeEkycDone && !payerCitizenId) ||
      (isInsuredNeedToBeEkycDone && isPayerNeedToBeEkycDone) ||
      isPayerNeedToBeEkycDone)
  )
    return true

  return false
}

class EkycSellingChannel extends React.Component {
  constructor(props) {
    super(props)
    this.refRootComponent = null
    this.previousFormEngineMaxWidth = undefined
    this.setRootComponentRef = (element) => {
      this.refRootComponent = element
    }
    this.state = {
      isSkipEkyc: false,
    }
  }

  componentDidMount() {
    const formEngineDom = findParentNodeTarget(this.refRootComponent)

    if (formEngineDom && IsRealDevice) {
      this.previousFormEngineMaxWidth = formEngineDom.style.maxWidth
      formEngineDom.style.maxWidth = '900px'
    }

    if ((!this.props.selectedRemoteSelling && !this.props.selectedF2F) || this.props.haveForeignerWithoutPassport) {
      this.props.checkSelectedF2F()
    }
  }

  componentWillUnmount() {
    const formEngineDom = findParentNodeTarget(this.refRootComponent)

    if (formEngineDom && IsRealDevice) {
      formEngineDom.style.maxWidth = ''
    }
  }

  render() {
    const {
      enableEkycOnDevice,
      checkEkycOnDevice,
      uncheckEkycOnDevice,
      isOpenNewRemoteSellingPreviewInfoModal,
      closeNewRemoteSellingPreviewInfoModal,
      shouldShowF2fOption,
      selectedRemoteSelling,
      selectedF2F,
      checkSelectedRemoteSelling,
      checkSelectedF2F,
      haveForeignerWithoutPassport,
      isSomeoneVerificationCompleted,
    } = this.props

    return (
      <>
        <NewRemoteSellingPreviewInfo
          isOpen={isOpenNewRemoteSellingPreviewInfoModal}
          onExit={closeNewRemoteSellingPreviewInfoModal}
        />
        <SendLinkRoomIdNotExist />
        <ResumeRMS />

        <div ref={this.setRootComponentRef} style={{ marginBottom: '2rem' }}>
          <Radio
            isHeading
            option={{ text: 'แบบเข้าพบลูกค้า (Face to face)', value: true }}
            subOptions={{}}
            active={selectedF2F}
            onClick={checkSelectedF2F}
            disabled={selectedRemoteSelling && isSomeoneVerificationCompleted}
          />
          {faceToFaceRadioOptions(shouldShowF2fOption, checkEkycOnDevice, uncheckEkycOnDevice, enableEkycOnDevice)}
          {getToggles().ENABLE_APPMAN_REMOTE_SELLING && !haveForeignerWithoutPassport && (
            <Radio
              isHeading
              option={{ text: 'แบบลูกค้าไม่สะดวกให้เข้าพบ (Remote Selling)', value: false }}
              subOptions={{}}
              active={selectedRemoteSelling}
              onClick={checkSelectedRemoteSelling}
              disabled={selectedF2F && isSomeoneVerificationCompleted}
            />
          )}
        </div>
      </>
    )
  }
}

const mapStateToEkycSellingChannel = (state, props) => {
  const app = getCurrentApp(state)
  const selectedRemoteSelling = isSelectedRemoteSelling(app)
  const selectedF2F = isSelectedF2F(app)
  const enableEkycOnDevice = isOnDeviceEKYC(app)
  const remoteSellingState = getRemoteSellingState(app)
  const isInCall = false
  const isPayerNeedToBeEkycDone = payerDoesEkyc(app)
  const isInsuredNeedToBeEkycDone = insurerDoesEkyc(app)
  const payerCitizenId = getCitizenId('payer')(app)
  let caseId = null
  const isForeignerPayer = isForeigner(app, 'payer')
  const isForeignerInsured = isForeigner(app, 'insured')
  const insuredPassport = getPassport('insured')(app)
  const payerPassport = getPassport('payer')(app)
  const isForeignerInsuredWithoutPassport =
    isForeignerInsured && !isEmpty(insuredPassport) && insuredPassport.length === 13
  const isForeignerPayerWithoutPassport = isForeignerPayer && !isEmpty(payerPassport) && payerPassport.length === 13
  const haveForeignerWithoutPassport = isForeignerInsuredWithoutPassport || isForeignerPayerWithoutPassport
  const hasPayer = havePayer(app)
  const isInsuredIdFaceRecognitionVerify = _getOr(
    false,
    'ekycInfo.insured.verificationDetail.idFaceRecognitionResult.verified',
    app
  )
  const consentedConfirmationLetterInsured = _getOr(
    false,
    'ekycInfo.insured.verificationDetail.insurancePolicyAgreementResult.response.confirmationAccepted',
    app
  )
  const consentedConfirmationLetterPayer = _getOr(
    false,
    'ekycInfo.payer.verificationDetail.insurancePolicyAgreementResult.response.confirmationAccepted',
    app
  )
  const dopaVerifiedInsured = _getOr(false, 'ekycInfo.insured.verificationDetail.dopaResult.verified', app)
  const dopaVerifiedPayer = _getOr(false, 'ekycInfo.payer.verificationDetail.dopaResult.verified', app)
  const someoneConsentedConfirmationLetter = hasPayer
    ? consentedConfirmationLetterPayer || isInsuredIdFaceRecognitionVerify
    : consentedConfirmationLetterInsured
  const someoneDopaVerified = hasPayer ? dopaVerifiedInsured || dopaVerifiedPayer : dopaVerifiedInsured
  const isSomeoneVerificationCompleted = selectedF2F ? someoneDopaVerified : someoneConsentedConfirmationLetter
  return {
    shouldShowF2fOption: checkShowingF2fOption(
      selectedRemoteSelling,
      isPayerNeedToBeEkycDone,
      isInsuredNeedToBeEkycDone,
      payerCitizenId
    ),
    selectedRemoteSelling,
    selectedF2F,
    enableEkycOnDevice,
    isOpenNewRemoteSellingPreviewInfoModal: false,
    isModalCreatingRemoteSellingOpen: false,
    creatingRemoteSellingCaseStatus: remoteSellingState?.creatingRemoteSellingCaseStatus,
    isInCall,
    caseId,
    haveForeignerWithoutPassport,
    someoneConsentedConfirmationLetter,
    isSomeoneVerificationCompleted,
  }
}

const mapDispatchToEkycSellingChannel = (dispatch, props) => ({
  checkEkycOnDevice: () => {
    dispatch(enableEkycOnDevice())
  },
  uncheckEkycOnDevice: () => {
    dispatch(disabledEkycOnDevice())
  },
  closeNewRemoteSellingPreviewInfoModal: () => {
    dispatch(closeNewRemoteSellingPreviewInfoModal())
  },
  closeCreatingRemoteSellingCaseModal: () => {
    dispatch(setAppValue(`remoteSelling.isModalCreatingRemoteSellingOpen`, false))
  },
  closeSendingLinkModalRemoteSelling: () => {
    dispatch(closeSendingLinkModalRemoteSelling())
  },
  closeRemoteSellingResumeModal: () => {
    dispatch(closeRemoteSellingResumeModal())
  },
  checkSelectedRemoteSelling: () => {
    dispatch(setAppValue('selectedRemoteSelling', true))
    dispatch(setAppValue('selectedF2F', false))
    dispatch(disabledEkycOnDevice())
  },
  unCheckSelectedRemoteSelling: () => {
    dispatch(setAppValue('selectedRemoteSelling', false))
  },
  checkSelectedF2F: () => {
    dispatch(setAppValue('selectedF2F', true))
    dispatch(setAppValue('selectedRemoteSelling', false))
  },
  unCheckSelectedF2F: () => {
    dispatch(setAppValue('selectedF2F', false))
  },
})

export default connect(mapStateToEkycSellingChannel, mapDispatchToEkycSellingChannel)(EkycSellingChannel)
